// extracted by mini-css-extract-plugin
export default {"Counter":"AutomationCountDown_Counter__irv+Y"};